import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { pluck, map } from 'rxjs/operators';
import { of } from 'rxjs';

interface FtSearchResponse {
  results: {
    name: {
      response: string;      
    }
  }[];

}

@Injectable({
  providedIn: 'root',
})
export class FtSearchService {
  constructor(private http: HttpClient) {}

  search(term: string) {
    const ftSearchUrl = '/api/controller/search';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded; charset=UTF-8'
      })
    }

    const formData = {
      'query':term,
      'actor':'investor',
      'parametrics':JSON.stringify([]),
      'collection':'literature,pages,funds',
      'start':'0',
      'number':'4',
      'sort':'relevance',
      'doNotSpellCheck':'false',
      'selectedTab':'',
      'hideTabs':'false',
      'locale':'en-usa',
      'loggedIn':'n',
    };

    const queryData = Object.keys(formData)
      .map(key => `${key}=${encodeURI(formData[key])}`)
      .join('&');

    return of([]);  

    return this.http.post<FtSearchResponse>(ftSearchUrl, queryData, httpOptions).pipe(
        pluck('results')
    );
  }
}

